import { MoreVertical } from 'lucide-react'
import type { AdminBookingAction } from '../../lib/admin-booking-actions'
import { canHardDeleteBooking, type AdminCanonicalBooking } from '../../lib/admin-workspace'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

export type AdminBookingMenuAction = AdminBookingAction

export function AdminBookingMenu({
  booking,
  includeDelete = false,
  onAction,
}: Readonly<{
  booking: AdminCanonicalBooking
  includeDelete?: boolean
  onAction: (booking: AdminCanonicalBooking, action: AdminBookingAction) => void
}>) {
  const cancelled = booking.status === 'cancelled' || booking.appointment_status === 'cancelled'

  function selectAction(action: AdminBookingAction) {
    window.setTimeout(() => onAction(booking, action), 0)
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          aria-label={`Actions for ${booking.public_reference}`}
          className="admin-row-menu-trigger"
          onPointerDown={(event) => event.stopPropagation()}
          type="button"
        >
          <MoreVertical size={18} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onCloseAutoFocus={(event) => event.preventDefault()}>
        <DropdownMenuItem onSelect={() => selectAction('view')}>
          View
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => selectAction('edit')}>
          Edit
        </DropdownMenuItem>
        {cancelled ? null : (
          <DropdownMenuItem onSelect={() => selectAction('cancel')}>
            Cancel
          </DropdownMenuItem>
        )}
        {includeDelete && canHardDeleteBooking(booking) ? (
          <DropdownMenuItem onSelect={() => selectAction('delete')}>
            Delete TEST booking
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
